import {useEffect} from 'react'

interface IListSearchContractAt {
  searchContractAtStart: string
  setSearchContractAtStart: (value: string) => void
  searchContractAtEnd: string
  setSearchContractAtEnd: (value: string) => void
  errorsContractAt: string[]
  setErrorsContractAt: (value: string[]) => void
}

const ListSearchContractAt = ({
  searchContractAtStart,
  setSearchContractAtStart,
  searchContractAtEnd,
  setSearchContractAtEnd,
  errorsContractAt,
  setErrorsContractAt,
}: IListSearchContractAt) => {
  useEffect(() => {
    if (searchContractAtStart.length === 10 && searchContractAtEnd.length === 10) {
      if (
        new Date(searchContractAtStart).setHours(0, 0, 0, 0) >
        new Date(searchContractAtEnd).setHours(0, 0, 0, 0)
      ) {
        const novosErros = [...errorsContractAt]
        novosErros[0] = 'Data inicial deve ser menor que data final'
        novosErros[1] = 'Data inicial deve maior que data final'
        setErrorsContractAt(novosErros)
        return
      }
    } else if (searchContractAtStart.length === 10 && searchContractAtEnd.length < 10) {
      const novosErros = [...errorsContractAt]
      novosErros[0] = ''
      novosErros[1] = 'Data final deve ser informada'
      setErrorsContractAt(novosErros)
      return
    } else if (searchContractAtEnd.length === 10 && searchContractAtStart.length < 10) {
      const novosErros = [...errorsContractAt]
      novosErros[0] = 'Data inicial deve ser informada'
      novosErros[1] = ''
      setErrorsContractAt(novosErros)
      return
    }
    const novosErros = [...errorsContractAt]
    novosErros[0] = ''
    novosErros[1] = ''
    setErrorsContractAt(novosErros)
  }, [searchContractAtStart, searchContractAtEnd])

  return (
    <>
      <div className='mb-5 row'>
        <div className='col-6'>
          <label className='form-label fs-6 fw-bold'>Pesquisar Por Data Do Contrato: Inicial</label>
          <input
            type='date'
            data-kt-user-table-filter='birthDate'
            className='form-control form-control-solid w-100'
            placeholder='Data inícial'
            value={searchContractAtStart}
            onChange={(e) => setSearchContractAtStart(e.target.value)}
            min='2015-12-31'
            maxLength={10}
          />
          {errorsContractAt && errorsContractAt.length > 0 && errorsContractAt[0] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fs-6'>{errorsContractAt[0]}</div>
            </div>
          ) : null}
        </div>
        <div className='col-6'>
          <label className='form-label fs-6 fw-bold'>Pesquisar Por Data Do Contrato: Final</label>
          <input
            type='date'
            data-kt-user-table-filter='dtEnd'
            className='form-control form-control-solid'
            placeholder='Data Final'
            value={searchContractAtEnd}
            onChange={(e) => setSearchContractAtEnd(e.target.value)}
            min='2015-12-31'
            maxLength={10}
          />
          {errorsContractAt && errorsContractAt.length > 0 && errorsContractAt[1] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fs-6'>{errorsContractAt[1]}</div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export {ListSearchContractAt}
